var BaseProperty = require("../../webvowl/elements/properties/BaseProperty");
var BaseNode  = require("../../webvowl/elements/nodes/BaseNode");
/** Помогает представлять JSON с VOWL для отображения. JSON получается результатом выполнения 
 * запроса к /mpo.mpo/graph_presentation */
 
module.exports = function (response) {
  var helper = {},	    
      vowl = (response)?response:undefined,
      conversionSettings={},  //Настройки преобразования owl в vowl
      header={languages:["undefined"], baseIris:[], iri:"", title:{}}, //Ещё может быть version и author (author может быть массивом)
      namespaces= [],
      classes= [],
      classAttributes=[],
      properties=[],
      propertyAttributes= [],
      statistics={lang:[], totals:[]}, //Статистика найденных элементов, для настройки header
      decorators=[], //Дополнительные декораторы
      externals=[]; //Дополнительные внешнии узлы


  helper.setResponse=function (response){
    vowl = (response)?response:undefined,
    conversionSettings = {},
    namespaces= [],
    classes= [],
    classAttributes=[],
    properties=[],
    propertyAttributes= [],
    statistics={lang:[]};
  }

  helper.setConversionSettings=function(settings){
    conversionSettings = (settings)?JSON.parse(JSON.stringify(settings)):{};
    //Обрабатываем логирование, т.к. логирование может быть в extra_options
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.logger){
      conversionSettings.logger = conversionSettings.settings.extra_options.logger;
    }    
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.decorators)
      decorators = conversionSettings.settings.extra_options.decorators;
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.externals)
      externals = conversionSettings.settings.extra_options.externals;
  }

  function empty(){
    header={languages:["undefined"], baseIris:[], iri:"", title:{}}, namespaces=[], 
    classes= [], classAttributes=[], properties=[], propertyAttributes= [], 
    statistics={lang:[], totals:[]};
  }

  /** Формирует список все классов в онтологии. 
   * По умолчнию  добавляется отдельные http://www.w3.org/2002/07/owl#Thing только если есть свойства, не меющие 
   * domain или range на объявленные классы
   * */
  helper.getClasses=function(){
    if ((classes.length<1) && vowl) 
      OWL2VOWL();
		return classes;
  };
  
  helper.getClassAttributes=function(){
    return classAttributes;
  }

  helper.getProperties=function(){
    if ((properties.length<1) && vowl)
      OWL2VOWL();
		return properties;
  };

  helper.getPropertyAttributes=function(){
    return propertyAttributes;
  }

  helper.updateDecorator=function(node, element){
    if (element.rdfType){
      let hasRdfType = false;
      const decordByRdfType = decorators.filter(decor => decor.pattern["rdfType"] == element.rdfType);
      if (Array.isArray(decordByRdfType) && decordByRdfType.length>0){
        const bg = decordByRdfType[0].decor["backgroundColor"];
        if (bg) node.backgroundColor(bg);
        this.updateStatistic(node, element, decordByRdfType[0]);
        hasRdfType = true;
      }
      //Сделаем заглушку для случая, когда тип задан в атрибуте, т.е. конструкция 
      // {"attribute": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", "value": "http://purl.org/linked-data/cube#ComponentSpecification"}
      const decordByAttrs = decorators.filter(decor =>
         ("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"==decor.pattern["attribute"]) && (element.rdfType==decor.pattern["value"])
      );

      if (Array.isArray(decordByAttrs) && decordByAttrs.length>0){
        const bg = decordByAttrs[0].decor["backgroundColor"];
        if (bg) node.backgroundColor(bg);
        if (!hasRdfType)
          this.updateStatistic(node, element, decordByAttrs[0])
      } ;
    }

    //Поищем для annotations
    if (element.annotations){
      const decordByAnnotations = decorators.filter(decorator => {
        const p = decorator.pattern;
        if (p.annotations && p.value) {
          return (element.annotations[p.annotations] || []).some(item => item.value === p.value);
        }
        return false;
      });
      decordByAnnotations.map(item => {
        const bg = item.decor["backgroundColor"];
        if (bg) 
          node.backgroundColor(bg);
        this.updateStatistic(node, element, item);
        }
      );
    };

    //Для Связей - т.к. они предикаты и их URI повторяются
    if (element.iri){
      const decordByIri = decorators.filter(decor => decor.pattern["iri"] == element.iri);
      if (Array.isArray(decordByIri) && decordByIri.length>0){
          this.updateStatistic(node, element, decordByIri[0])
      };
    }
  }
  
  helper.getTitle = function(){
    return header.title;
  }

  helper.getHeader = function(){
    if (Array.isArray(statistics.totals) && statistics.totals.length>0){
      header.totals = statistics.totals
        .filter(item => item)
        .filter(item => item.group == "nodes")
        .map(total=> total.stat.name+total.elements.length);
      header.statNodes =  statistics.totals
        .filter(item => item)
        .filter(item => item.group == "nodes")
        .map(total=> total.stat.name+total.elements.length);
      header.statEdges  = statistics.totals
        .filter(item => item)
        .filter(item => item.group == "edges")
        .map(total=> total.stat.name+total.elements.length);
    };
    return header;
  }

  /** Визуальные настройки правой боковой панели см. sparqlSidebar.js. Если таких настроек 
   * нет, то  возвращается undefined */
  helper.getSlideBarSettings = function(){
    if ( conversionSettings && conversionSettings.settings && conversionSettings.settings.extra_options
      && conversionSettings.settings.extra_options.slideBar)
      return conversionSettings.settings.extra_options.slideBar;
    return undefined;
  }

  helper.getNamespaces=function(){
    return namespaces;
  }

  helper.getData = function (){
    return vowl;
  }

  helper.getVOWL = function () {
    return vowl;
  }
  
  function OWL2VOWL(){
    empty();
    header = vowl.header;
    header.totals = [];
    header.statNodes = [];
    header.statEdges = [];
    namespaces = vowl.namespace;
    properties = vowl.property;
    propertyAttributes = vowl.propertyAttribute;
    classes = vowl.class;
    classAttributes = vowl.classAttribute;
    //Финальная пост обработка
    vowlAfterOWL2VOWL();
  }



  function vowlAfterOWL2VOWL(){
    // const noSingels = things.filter(t=> !t.single);
    // if (noSingels.length>0){
    //   let thingDomain = (singleThing)?singleThing:noSingels[0].id;
    //   for (let i = 0; i < things.length; i++) {
    //     const thing = things[i];
    //     if (thing.single) continue;
    //     if (singleThing){
    //       const index = nodes.length;
    //       nodes.push({"id": index, "type": "CloneNode"});
    //       nodeAttributes.push({range: thing.id.toString(), id: index, domain: singleThing.toString(), "attributes" : [ "anonymous" ]});    
    //     }
    //   }  
    // }
    // const langs = statistics.lang.sort((a, b) => a.count - b.count)
    // header.languages = [];
    // // const languages = langs.map(item => item);
    // // header.languages = languages;
    // const keys = Object.keys(langs);
    // for (let i = 0; i < keys.length; i++) {
    //   const lang = langs[keys[i]]; 
    //   header.languages[i] = lang.name;
    // }
    // if (header.languages.length<1) header.languages = ["undefined"];
    // if (!(header.languages.some(lang => lang=="undefined")))
    //   header.languages[header.languages.length] = "undefined";
    // //Установим максимальный вес языка для указанного в настройках
    // if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.defaultLanguage){
    //   const lang = conversionSettings.settings.extra_options.defaultLanguage;
    //   header.languages = header.languages.filter(item => item !== lang);
    //   header.languages = [lang, ... header.languages];
    //   header.defaultLanguage = lang;
    // }
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.legend){
      header.legend = conversionSettings.settings.extra_options.legend;
    }    
    if (conversionSettings.legend)
      header.legend = conversionSettings.legend;
  }

  /** Пересчитывает статистику по элементам из декоратора */
  helper.updateStatistic=function(node, element, decorator){
    //Проверка, статистика для ребра (могут совпадать условия для ребра или узла)
    if (node instanceof BaseProperty && !decorator.hasOwnProperty("statEdges")) return;
    //Проверка, статистика для узла
    if (node instanceof BaseNode && !(decorator.hasOwnProperty("statNodes") || decorator.hasOwnProperty("stat")))return

    if (decorator && (decorator.hasOwnProperty("stat") || decorator.hasOwnProperty("statNodes") || decorator.hasOwnProperty("statEdges"))){
      const statKey =decorator.hasOwnProperty("statNodes")? "statNodes": (decorator.hasOwnProperty("statEdges")?"statEdges":"stat");
      const stat = decorator[statKey];
      if (typeof statistics.totals[stat.id] === 'undefined'){
        const typeStat = decorator.hasOwnProperty("statEdges")?"edges": "nodes";
        statistics.totals[stat.id] = {stat: stat, elements: [], group: typeStat};
      };
      const total = statistics.totals[stat.id];
      const statElement = (statKey == "statEdges")? element.id: element.iri;
      if (total.elements.indexOf(statElement)<0)
        total.elements.push(statElement)
    }
    //console.log("sparqlHelper.js helper.updateStatistic", node, element, decorator, statistics);
  }

  return helper;

};